import Opros from "../components/opros/Opros";
import { Helmet } from "react-helmet";
function Order (){
    return (
        <>
            <Helmet>
                <title>Заказать сайт, мобильное приложение, чат бота</title>
                <meta name="description" content="Технический опросник для того, что бы заказать сайт, мобильное приложение или чат бота"/>
            </Helmet>
        <Opros/>
        </>
    );
}

export default Order;